const isStripeID = (type: 'price' | 'txr' | 'prod', value?: string) =>
  Boolean(
    value?.match(
      new RegExp(`^${type}_[a-zA-Z0-9]{${type === 'prod' ? 14 : 24}}$`),
    ),
  );

export default isStripeID;
